import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { Slice, GiftCardApplySlice } from './types'
import { setCart } from '../cart'
import { PWAThunk } from 'lib/core/data'

export const initialState: Slice = {}

interface ActionData {
  cartId: string
}

const getSlice = (slice: GiftCardApplySlice): GiftCardApplySlice => {
  return slice ?? ({
    isFetching: false,
    isSuccess: false,
    isFailure: false
  })
}

const slice = createSlice({
  name: 'quote/giftCardRemove',
  initialState,
  reducers: {
    request (state, action: PayloadAction<ActionData>) {
      const { cartId } = action.payload
      const slice = getSlice(state[cartId])
      slice.isFetching = true
      state[cartId] = slice
    },

    success (state, action: PayloadAction<ActionData>) {
      const { cartId } = action.payload
      const slice = getSlice(state[cartId])
      slice.isFetching = false
      slice.isSuccess = true
      slice.isFailure = false
    },

    failure (state, action: PayloadAction<ActionData>) {
      const { cartId } = action.payload
      const slice = getSlice(state[cartId])
      slice.isFetching = false
      slice.isSuccess = false
      slice.isFailure = true
    }
  }
})

export const reducer = slice.reducer

export const { request, success, failure } = slice.actions

export function giftCardRemove (cartId: string, giftCard: string): PWAThunk {
  return async (dispatch, getState, params) => {
    const { magentoClient } = params
    dispatch(request({ cartId }))
    try {
      const response = await magentoClient.getClient().quote.giftCardRemove({
        cartId,
        giftCard
      })

      const { data } = response
      const { removeGiftCardFromCart } = data
      const { cart } = removeGiftCardFromCart

      if (cart) {
        dispatch(setCart({
          cartId,
          data: cart,
          merge: true
        }))
        dispatch(success({ cartId }))
      } else {
        dispatch(failure({ cartId }))
      }

      return response
    } catch (e) {
      dispatch(failure({ cartId }))
    }
  }
}
